// Import only the data source we need
import * as dataSource from "./sanae.json";

// Export the data source
export const data = dataSource;
